export const BR_DISPO_LINK =
  'https://disneyworld.disney.go.com/availability-calendar/?locale=pt-br&segments=tickets,resort';
export const BR_OFFICIAL_SITE_LINK =
  'https://www.disneytravelcenter.com/MIN-000000000044387/sites++walt-disney-world++kbyg++kbyg-ws-ms/';
export const BR_ATTACH_TICKETS_LINK =
  'https://disneyworld.disney.go.com/pt-br/login/?returnUrl=%2Fprofile%2F';

export const AR_DISPO_LINK =
  'https://disneyworld.disney.go.com/availability-calendar/?locale=en-us&segments=tickets,resort';
export const AR_OFFICIAL_SITE_LINK =
  'https://disneyworld.disney.go.com/es-ar/travel-information-latam/';
export const AR_ATTACH_TICKETS_LINK = 'https://disneyworld.disney.go.com/es-ar/login/';
